import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {redirectToPHPComponent} from './default';

const NewsIndex      = () => import('../views/news/NewsIndex.vue');
const NewsList       = () => import('../views/news/NewsList.vue');
const NewsView       = () => import('../views/news/NewsView.vue');
const NewsEdit       = () => import('../views/news/NewsEdit.vue');
const NewsSettings   = () => import('../views/news/NewsSettings.vue');
const GlobalNewsView = () => import('../views/news/global/GlobalNewsView.vue');

export const newsBasicBreadcrumbs: Breadcrumb[] = [
    {
        label: 'Meldungen',
        href: {name: 'news-list'},
    },
];

let meta: MetaData = {module: 'news'};

let news: RouteRecordRaw[] = [
    {
        path: '/news',
        redirect: {name: 'news-list'},
        meta,
    },
    {
        path: '/news/list/',
        component: NewsIndex,
        meta,
        children: [
            {
                path: '',
                redirect: {name: 'news-list'},
            },
            {
                path: 'expired/:category?',
                name: 'news-list-expired',
                component: NewsList,
                props: {type: 'expired'},
                meta,
            },
            {
                path: 'inactive/:category?',
                name: 'news-list-inactive',
                component: NewsList,
                props: {type: 'inactive'},
                meta,
            },
            {
                path: ':category?',
                name: 'news-list',
                component: NewsList,
                meta,
            },
        ],
    },
    {
        path: '/news/view/id/:id/:wildcard*',
        name: 'news-view',
        component: NewsView,
        meta,
    },
    {
        path: '/news/edit/id/:id/:wildcard*',
        name: 'news-edit',
        component: NewsEdit,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id)};
        },
        meta,
    },
    {
        path: '/news/add',
        name: 'news-add',
        component: NewsEdit,
        props: {id: 0},
        meta,
    },
    {
        path: '/news/global/view/id/:id',
        name: 'global-news-view',
        component: GlobalNewsView,
    },
    {
        path: '/news/settings/:route(intranet)?',
        name: 'news-settings',
        component: NewsSettings,
        meta,
        children: [
            {
                path: 'rights',
                name: 'news-settings-rights',
                meta,
                component: NewsSettings,
            },
            {
                path: 'category',
                name: 'news-settings-categories',
                meta,
                component: NewsSettings,
            },
        ],
    },
    // COMPATIBILITY: OLD PATHS
    {
        path: '/news/news/list/:wildcard*',
        redirect: {name: 'news-list'},
        meta,
    },
    {
        path: '/news/news/view/id/:id/:wildcard*',
        redirect: {name: 'news-view'},
        meta,
    },
    {
        path: '/news/news/edit/id/:id/:wildcard*',
        redirect: {name: 'news-edit'},
        meta,
    },
    {
        path: '/news/news/edit',
        redirect: {name: 'news-add'},
        meta,
    },
    {
        path: '/news/edit',
        redirect: {name: 'news-add'},
        meta,
    },
    {
        path: '/news/news/inactive-news',
        redirect: {name: 'news-inactive'},
        meta,
    },
    {
        path: '/news/news/expired-news',
        redirect: {name: 'news-expired'},
        meta,
    },
    {
        path: '/news/news/setEditors',
        redirect: {name: 'news-editor'},
        meta,
    },
    {
        path: '/news/global/view/id/:id?',
        component: redirectToPHPComponent,
        meta,
    },
    {
        path: '/news/categories',
        redirect: {name: 'news-settings-categories'},
        meta,
    },
    {
        path: '/news/editor',
        redirect: {name: 'news-settings-rights'},
        meta,
    },
    // all other news routes redirect to news-list (maybe to 404?)
    {
        path: '/news/:wildcard*',
        redirect: {name: 'news-list'},
        meta,
    },
];

export default news;
